<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field>
          <form-select :label="`${$t('docflow.fields.type')} *`" v-model="form.document_type">
            <option v-for="type in types" :value="type.id">{{ type.name }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-input :label="`${$t('docflow.fields.registration_number')} *`"
                      mask="9a-999"
                      v-model="form.registration_number"></form-input>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker :label="$t('docflow.fields.term_date')" :min-date="minDate"
                           v-model="form.term_date"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <EmployeeSelect :initials="form.resolution_author__initials"
                          :label="`${$t('docflow.fields.resolution_author')} *`"
                          :scope-all="true"
                          v-model="form.resolution_author">
          </EmployeeSelect>
        </b-field>
      </div>
      <div class="column is-6">
        <span class="has-text-grey mt-5" v-html="$t('interface.selfAssign')"></span>
      </div>
      <div class="column is-12 mt-10">
        <b-checkbox v-model="form.is_informational">{{
          this.detail.category === 'appeal' ? $t('docflow.resend_appeal') : $t('docflow.is_informational')
        }}</b-checkbox>
        <b-checkbox v-model="form.is_classified" class="ml-40">{{ $t('docflow.fields.is_classified') }}</b-checkbox>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'
  import moment from 'moment'

  const defaultDocumentData = {
    registration_number: '',
    document_type: null,
    term_date: new Date(),
    resolution_author: null,
    is_informational: false,
    is_classified: false
  }

  export default {
    props: ['documentData', 'editMode'],
    components: {
      EmployeeSelect,
      GovernmentAgencySelect
    },
    data() {
      return {
        form: this.documentData || {...defaultDocumentData},
        isEdit: this.editMode || false,
        errors: [],
        minDate: moment().subtract(1, 'days').toDate(),
        maxDate: new Date()
      }
    },
    methods: {
      validate() {
        this.errors = []
        if (this.form.document_type === null || this.form.registration_number === '') {
          this.errors.push(this.$t('interface.requiredFields'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            term_date: this.form.term_date ? prepareDate(this.form.term_date) : null,
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    computed: {
      ...mapState('Docflow', ['types', 'detail'])
    },
    watch: {
      documentData(document) {
        this.form = document
      }
    }
  }
</script>